/*!
 * Copyright (c) 2026 Elevation Technologies Pte Ltd.
 * Developer: filimoni@elevationtech.com.fj
 */
export const FSF_BRAND = {
  "name": "Freight Services Fiji",
  "tagline": "#CONNECTING THE PACIFIC TO THE WORLD",
  "logo": "/wp-content/uploads/2022/05/FSFLogoHW-768x158.png",
  "quoteUrl": "https://forms.office.com/Pages/ResponsePage.aspx?id=ZEks_dNnz0ulLmgm_2Y59WPqEZAIyR1Ho5gy4CQFhQxUNFowVzIxRDBZWkg2TUFYUjdMMDNRNTVZSC4u",
  "socials": [
    {
      "label": "Instagram",
      "href": "https://www.instagram.com/freightservicesfiji/"
    },
    {
      "label": "Facebook",
      "href": "https://www.facebook.com/freightservicesfiji/"
    },
    {
      "label": "Youtube",
      "href": "https://www.youtube.com/channel/UCZTjJ_Qd8M7dS6-hJbH6CSA"
    },
    {
      "label": "Linkedin",
      "href": "https://www.linkedin.com/company/freight-services-fiji-ltd-suva/"
    },
    {
      "label": "Whatsapp",
      "href": "https://wa.me/6799978831"
    }
  ]
};

export const FSF_NAV = [
  {
    "label": "Home",
    "href": "/"
  },
  {
    "label": "About Us",
    "children": [
      {
        "label": "In The Beginning",
        "href": "/about-us/"
      },
      {
        "label": "Our Ethics, Values & Culture",
        "href": "/our-ethics-values-culture/"
      },
      {
        "label": "Quality Assurance & Control",
        "href": "/quality-assurance-control/"
      },
      {
        "label": "Global Network & Partners",
        "href": "/global-network/"
      }
    ]
  },
  {
    "label": "Logistics Division",
    "href": "/logistics/"
  },
  {
    "label": "Moving Division",
    "href": "/moving/"
  },
  {
    "label": "Contact Us",
    "href": "/contactus/"
  }
];

export const FSF_PAGES = {
  "home2026": {
    "slug": "home2026",
    "title": "Freight Services Fiji",
    "description": "Professional logistics and moving services connecting the Pacific to the world.",
    "legacyUrl": "https://fsf.com.fj/",
    "featuredImage": "/wp-content/uploads/2022/05/IMG_1411-1024x683.jpg",
    "heroVideo": "https://youtu.be/QNUX7mPkZ2c",
    "links": [
      {
        "label": "Home",
        "href": "/home/"
      },
      {
        "label": "About Us",
        "href": "/#"
      },
      {
        "label": "In The Beginning",
        "href": "/about-us/"
      },
      {
        "label": "Our Ethics, Values & Culture",
        "href": "/our-ethics-values-culture/"
      },
      {
        "label": "Quality Assurance & Control",
        "href": "/quality-assurance-control/"
      },
      {
        "label": "Global Network & Partners",
        "href": "/global-network/"
      },
      {
        "label": "Logistics Division",
        "href": "/logistics/"
      },
      {
        "label": "Moving Division",
        "href": "/moving/"
      },
      {
        "label": "Contact Us",
        "href": "/contactus/"
      },
      {
        "label": "Transit Warehouse Solutions",
        "href": "/transit-whs/"
      },
      {
        "label": "3PL | Distribution & Fulfilment",
        "href": "/ocean-products/"
      },
      {
        "label": "Warehouse Storage Solutions",
        "href": "/airproducts/"
      }
    ],
    "blocks": [
      {
        "type": "html",
        "html": "<h1><span>Freight Services (Fiji) is a professional Logistics & Moving Service Provider with multiple branches </span><span>and trusted partners all over the South Pacific region.</span><span> </span></h1><h1><span><span>Our Headquarters is located in Suva, Fiji – a natural cargo hub that provides 360° logistics for all types of cargo and transport options available. </span></span></h1>"
      },
      {
        "type": "html",
        "html": "<p><span><span>At </span><strong>Freight Services Fiji</strong><span>, we believe quality isn’t optional — it’s our standard. Every customer, whether just around the corner or across the globe, receives the same level of care, professionalism, and excellent service.</span></span></p><p><span>From here in the heart of the South Pacific to our partners and clients around the world, we move more than cargo — we move trust. Customer feedback helps our team keep improving.</span></p><p><img src=\"/wp-content/uploads/2026/02/gb1-300x101.png\" alt=\"\" /></p>"
      },
      {
        "type": "video",
        "url": "https://youtu.be/72CmxQtAL74?si=-fsOPpd4mHgf0teP"
      },
      {
        "type": "video",
        "url": "https://youtu.be/Gmiht9ra0PE?si=ueSp-d9A3TMhQ9pz"
      },
      {
        "type": "gallery",
        "images": [
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/FSFLogoHW-300x62.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/2-1024x504.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/IMG_0298-300x200.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/0-02-07-6fbbca32cfcce14cacb8f6840ff6231a22cb5a60a09b51c746b1854e8c1c3c7a_73d83be445ed67b-225x300.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/IMG_1166-300x200.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/0-02-07-7339a65a118bb0806c30829a0c49b2c38521d06cc57b7e897009fcd98975ae77_5bd26a4180b3e1dd-Copy-225x300.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/09/AIRR-e1771834117452-300x220.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/IMG_1411-300x200.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/itb2-e1770597317633.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/gb1-300x101.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/IMG_1185-1024x683.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2023/06/pacific2-e1752799273593.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/mov2.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/IMG_1741.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/IMG_0306.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/IMG_0684.jpg",
            "alt": ""
          }
        ]
      }
    ]
  },
  "home": {
    "slug": "home",
    "title": "Freight Services Fiji",
    "description": "Professional logistics and moving services connecting the Pacific to the world.",
    "legacyUrl": "https://fsf.com.fj/home/",
    "featuredImage": "/wp-content/uploads/2023/06/pacific2-e1752799273593.png",
    "heroVideo": "https://youtu.be/QNUX7mPkZ2c",
    "links": [
      {
        "label": "Get a Quotation today!",
        "href": "https://forms.office.com/Pages/ResponsePage.aspx?id=ZEks_dNnz0ulLmgm_2Y59WPqEZAIyR1Ho5gy4CQFhQxUNFowVzIxRDBZWkg2TUFYUjdMMDNRNTVZSC4u"
      },
      {
        "label": "Click Here to Access",
        "href": "https://www.youtube.com/watch?v=tuPfyV9t5rc"
      },
      {
        "label": "Sustainability",
        "href": "/corporate-social-responsibility-2/"
      }
    ],
    "blocks": [
      {
        "type": "html",
        "html": "<h1><span><strong>BULA VINAKA AND WELCOME TO </strong><span><strong>THE SOUTH PACIFIC’S VERY OWN GLOBAL CARGO HUB</strong></span></span></h1><p><span>Freight Services Fiji is a premier logistics and freight forwarding company, Strategically, positioned in Fiji to serve as a link between the beautiful islands of the Pacific and the world. We connect businesses and individuals across the South Pacific to global markets with ease and efficiency.  Embark on this journey with us as we traverse through the South Pacific Ocean through Air, Sea and Land to ensure that cargoes are delivered on time, at the right location and received by the right recipient to and from the beautiful islands of the South Pacific Ocean.</span></p><p><span>Book with us today and together, lets</span> <span><strong>#ConnectThePacificToTheWorld</strong>.</span></p>"
      },
      {
        "type": "html",
        "html": "<h1><span><span><span>QUALITY MANAGEMENT STANDARD & CONTROL</span></span></span></h1><p>At Freight Services Fiji, we are deeply committed to upholding the highest standards of quality in every aspect of our operations. Our dedication to excellence is reflected in our rigorous internal processes, customer-centric approach, and continuous improvement initiatives.</p><p><span>As part of our commitment to quality, we are proud to be ISO 9001:2015 Quality Management System certified, demonstrating our adherence to globally recognized standards for operational efficiency and customer satisfaction. Additionally, we hold the prestigious FIDI-FAIMPLUS certification—the highest and most stringent accreditation in the international moving and relocation industry—further affirming our capability to deliver world-class services with professionalism, consistency, and integrity.</span></p>"
      },
      {
        "type": "html",
        "html": "<h1><span><span><strong>UTILIZING TECHNOLOGY – DIGITILIZATION FOR PRODUCTIVITY</strong></span></span></h1><p>At Freight Services Fiji, we leverage the latest technology and digital tools to boost productivity and deliver faster, more efficient service. From real-time tracking to automated workflows, our tech-driven approach enhances operations, improves transparency, and keeps us ahead in the logistics industry.</p><p>We’re excited to offer this enhanced service to make your experience with us even more efficient and transparent. With just your shipment reference number, you can easily track the progress of your cargo in real time instead of having to contact us directly.</p><p>If you wish to find out more about this cargo tracking tool, please click this link: <strong><a href=\"https://www.youtube.com/watch?v=tuPfyV9t5rc\">Click Here to Access</a></strong></p>"
      },
      {
        "type": "html",
        "html": "<h1><span><span><strong>THE FUTURE IS GREEN – ENVIRONMENTAL SUSTAINABILITY</strong></span></span></h1><p>Freight Services Fiji is committed to environmental sustainability by promoting responsible logistics practices that reduce our carbon footprint. We continuously seek eco-friendly solutions—from optimizing delivery routes to minimizing waste and supporting greener technologies—because we believe a cleaner, more sustainable future starts with the choices we make today.</p>"
      },
      {
        "type": "html",
        "html": "<p>The management team at Freight Services Fiji is committed to championing environmental responsibility and leading by example. As part of our sustainability efforts, we’ve taken our message on the road—literally—by using our delivery trucks as moving billboards to raise awareness about the importance of sustainable business practices. Through eye-catching visuals and bold messaging, we aim to inspire other businesses in Fiji to join us in driving real change toward a greener, more responsible future.</p>"
      },
      {
        "type": "html",
        "html": "<p>If you wish to view our corporate and social responsibility statement – please click here:</p>"
      },
      {
        "type": "gallery",
        "images": [
          {
            "type": "image",
            "src": "/wp-content/uploads/2023/06/pacific2-e1752799273593.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/IMG_1185-768x512.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/2.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/3.jpg",
            "alt": ""
          }
        ]
      }
    ]
  },
  "about-us": {
    "slug": "about-us",
    "title": "In The Beginning",
    "description": "The story of Freight Services Fiji from its founding in 1996 to its role as a South Pacific cargo hub.",
    "legacyUrl": "https://fsf.com.fj/about-us/",
    "featuredImage": "/wp-content/uploads/2023/06/main-e1686518124758.jpg",
    "heroVideo": null,
    "links": [
      {
        "label": "Please click this link to access the signed Letter of Commitment by Mr. Taoi.",
        "href": "https://drive.google.com/file/d/1-SFeuncKl5FsBWks2rzkuNmROZne99UJ/view?usp=drivesdk"
      }
    ],
    "blocks": [
      {
        "type": "html",
        "html": "<h1><span><strong>IN THE BEGINNING</strong></span></h1><p>Freight Services (Fiji) was established in the year, 1996 and started of its journey as a leading Export and Import service provider for overseas investors who invested in Fiji to make use of the benefits given through market forces and international trade policies such as the GATT 1994 agreement.</p><p>The subsequent negotiations, trade barriers such as tariffs and quotas were gradually reduced, creating more favorable conditions in international trade for those countries who were under this multilateral union.</p>"
      },
      {
        "type": "html",
        "html": "<p><strong>Click on the WTO Logo to view the </strong></p><p><strong>Fiji: </strong>1997 Trade Policy Review</p>"
      },
      {
        "type": "html",
        "html": "<p>Fiji became a member of the WTO in January 1996 and immediately felt the benefits of being a member through lower tariffs and improved market access. This trade lane created the platform for Freight Services (Fiji) to expand its operations and connect the Pacific to the world on a larger scale.</p><p>Making the most of this market opportunity, Mr. Joe Taoi had made the bold decision to leave his place of stability of employment and venture into a new field altogether, a field of business. Back in the 90’s, seeing Fijians becoming businessmen was extremely rare and to see this young man (26 years old) make the decision to become that rare Fijian to make a difference in the social dynamics was something to behold.</p><p>Stories are often told of how Mr. Taoi had taken Freight Services (Fiji) up into his own arms as if it was his own child. He nurtured it, spent time with it, invested in it and sure enough just as he was hoping for, the company did not let him down but instead acted as a springboard for him to pursue other ventures while managing it at the same time.</p>"
      },
      {
        "type": "html",
        "html": "<p>With nothing to lose, a head full of knowledge on the logistics and trade industry (having worked at BP Shipping and DHL – the two major multinational shipping companies at the time) and a burning desire to take advantage of the benefits the nation was receiving from this trade agreement, Mr. Taoi had made plans with business partner and company co-founder, Mr. Francis Hong Tiy to open two sister companies. Shipping Services (Shipping line agent) and Freight Services (The Freight Forwarder / Cargo Agent).</p><p>Mr. Hong Tiy had invested his personal funds into the opening of these 2 companies and had entrusted Mr. Taoi with partial ownership of Freight Services (Fiji) through the handing of shares due to his loyalty and hard work. Both companies expanded and eventually, Mr. Taoi had purchased all the shares from Mr. Hong Tiy, thus making him the sole owner of Freight Services (Fiji). Mr. Taoi, through determination and hard work, had weathered many storms which made him resilient and more experienced in business.</p><p>He later expanded the company by increasing the popularity of the company on the global stage, opening branches in different countries and pursuing the highest quality certifications the world has to offer. He also expanded the company and created more revenue streams into its operations. Towards the end of his career, He was appointed on multiple boards of Fiji such as FNPF, TFL, Vodafone and HFC.</p><p>Unfortunately, he was called to rest in February 2025 after battling a very severe case of cancer. Although his life was cut short, the relationships he built, the memories he made, the organization he built and the love that he portrayed will be something that will be cherished in the hearts of many. It can be said that he died a happy man who lived a life most dream of living. An inspiration to his children. Friends and the entire nation of what hard work can do as he always liked to say “Na tamata dou cakacaka se sega ni dou madua taka dua na ka” </p>"
      },
      {
        "type": "html",
        "html": "<h1><span><strong>A YOUNG MAN’S DREAM</strong></span></h1><p>On a rocky land, a young man stands,</p><p>With a mind so bright, and eager hands,</p><p>His eyes fixed on the distant seas,</p><p>A vision of business, he longs to seize.</p><p>With dreams of commerce, he ponders wide,</p><p>Of freight and trade, beyond the tides,</p><p>Of opening pathways, to the world beyond,</p><p>And building bridges, from the Pacific Pond.</p><p>With boundless energy, and fearless heart,</p><p>He sets forth to make his mark,</p><p>With grit and passion, he works each day,</p><p>And slowly, surely, he paves the way.</p><p>He reaches out, to lands afar,</p><p>To customers, partners, and shippers by far,</p><p>Building networks, from shore to shore,</p><p>And opening doors, that were closed before.</p><p>Through the waves, his cargoes sail,</p><p>Bringing goods and growth, to his native trail,</p><p>And with each success, his star does rise,</p><p>A beacon of hope, in Fijian skies.</p><p>And as the world takes notice of his feat,</p><p>They marvel at his courage, and his fleet,</p><p>A young Fijian, who dared to dream,</p><p>And made the Pacific, a global stream.</p><p>So let us celebrate this Young Man so bold,</p><p>Who opened the world, with his courage untold,</p><p>For he is a symbol, of our islands light</p><p>And is a beacon of hope, in the darkest night</p>"
      },
      {
        "type": "html",
        "html": "<p><em>The above is a poem which Joeli had made for his father a few years ago to describe the life lived by his father as a young Fijian man with humble beginnings coming from the village to the city to live out his dream. This poem was also read during Mr. Taoi’s Eulogy by his son Joeli as his last goodbye to his teacher, role model, father and mentor.</em></p>"
      },
      {
        "type": "html",
        "html": "<p>As for Freight Services (Fiji) and its management, it is safe to say that it is in capable hands being run by his four children, Api, Tom, Jjoe and Soph. They look forward to taking the company to a higher level than what their father had left it at and with teamwork and adherence to the quality management standards set up by their father, there is no telling on how far the company could expand.</p><p>It recently has since joined the United Nations in their efforts for a more sustainable society by joining the United Nations Global Compact. #UnitingBusiness with the #UnitedNations.</p><p><a href=\"https://drive.google.com/file/d/1-SFeuncKl5FsBWks2rzkuNmROZne99UJ/view?usp=drivesdk\">Please click this link to access the signed Letter of Commitment by Mr. Taoi.</a></p><p>A perfect start towards the journey in #ConnectingThePacificToTheWorld.</p>"
      },
      {
        "type": "html",
        "html": "<h1><span><strong>THE LIGHT OF THE PACIFIC</strong></span></h1><p>“You are the light of the world. A city that is set on a hill cannot be hidden. Nor do they light a lamp and put it under a basket, but on a lampstand, and it gives light to all who are in the house. Let your light so shine before men, that they may see your good works and glorify your Father in heaven.” –</p><p>Matthew 5:14- 16</p><p>It is not in trying to “Be” that we “Become” <span><strong>the Light</strong></span> the world desires to find. It is in the wwillingness to serve our customers that we naturally become:</p><ul><li><span><strong>T</strong><strong>he Light</strong></span> our customers and networks seek diligently for</li><li><span><strong>The Light</strong> </span>that displays its radiance from the South Pacific</li><li><span><strong>The Light</strong></span> that begins from the East and Spans to the West</li><li><span><strong>The Light</strong></span> that reaches towards the ends of the World.</li></ul><p>Click on the image below to receive your gift from us here at FSF, VINAKA.</p>"
      },
      {
        "type": "gallery",
        "images": [
          {
            "type": "image",
            "src": "/wp-content/uploads/2023/06/WTO.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2023/06/main-e1686518124758.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/itb2-e1770597317633.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/itb3.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/itb4b-e1770597466767.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2023/06/x1.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2023/06/trees.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2023/06/road.png",
            "alt": ""
          }
        ]
      }
    ]
  },
  "our-ethics-values-culture": {
    "slug": "our-ethics-values-culture",
    "title": "Our Ethics, Values & Culture",
    "description": "The ethics, values, and Pacific culture that shape how FSF serves customers and community.",
    "legacyUrl": "https://fsf.com.fj/our-ethics-values-culture/",
    "featuredImage": "/wp-content/uploads/2026/04/WEB-3.jpg",
    "heroVideo": null,
    "links": [],
    "blocks": [
      {
        "type": "html",
        "html": "<p><strong>At Freight Services Fiji, our greatest asset isn’t found in warehouses or on wheels—it’s found in our people.</strong></p><p>As representatives of the company, we hold ourselves to the highest standards of ethics and values, knowing that trust, respect, and accountability are the foundation of lasting relationships with our clients and partners. It’s not just about moving freight—it’s about moving forward together with purpose, pride, and people at the heart of everything we do. That is why we ensure to uphold the very values taught to us by our elders and embraced by the <em>Vanua</em>—the land and its people.</p><p>These values—<em>veirokovi</em> (mutual trust), <em>veinanumi</em> (consideration), and <em>solesolevaki</em> (communal cooperation)—aren’t simply words; they are the living, breathing essence of how we operate as a team and as a company. In every container we move, in every mile our trucks travel, and in every hand we shake, we carry with us the spirit of unity and the legacy of service. Our success is not measured solely by the volume of cargo we deliver, but by the integrity with which we conduct our work and the respect we show to one another along the way.</p><p>At the core of our operations is a strong belief in <em>solesolevaki</em>—teamwork. It is through the strength of our shared purpose that we ensure efficient, smooth workflows, support each other in moments of pressure, and celebrate our collective achievements. Whether in the office, on the docks, behind the wheel, or in the warehouse, every person plays an essential role. We do not work in silos—we move as one, helping one another and offering support to those who need it, because we know that a strong team is what delivers strong results.</p>"
      },
      {
        "type": "html",
        "html": "<p><span>The teachings of our elders remind us that true leadership is shown in service, humility and vision. We carry these teachings forward in our everyday work, with the understanding that each task – no matter how small – is a contribution to something greater. Our clients trust us not only with their cargo, but with their business continuity, reputation, and peace of mind. We honor that trust by being diligent, transparent while embracing the need to strive for excellence whenever we perform our services. </span></p><p>We are also deeply aware of our responsibility to the environment and the communities we operate in. Our connection to the Vanua reminds us that sustainability and stewardship are not just policies –  they are responsibilities inherited from those who came before us and have entrusted it to us for the sake of those who will come after. From our logistics decisions to our internal culture, we act with the future in mind, understanding that progress must always be balanced with respect for people and the land.</p><p>Following the phrase created by the late great Ratu Sir Kamisese Mara, The Pacific Way and implementing its fundamentals, we consider our day to day approach similar to a journey of purpose rooted with a desire to uphold our virtues with a deep commitment to excellence when serving. Freight Services Fiji is a family built not only on logistics, but on love for the land, for our people and for those who will come in the future .</p>"
      },
      {
        "type": "gallery",
        "images": [
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/04/111-1.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/04/222-2-1024x480.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/04/333-2-1024x474.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/04/444-3-768x378.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/04/555-2.jpg",
            "alt": ""
          }
        ]
      }
    ]
  },
  "quality-assurance-control": {
    "slug": "quality-assurance-control",
    "title": "Quality Assurance & Control",
    "description": "Quality management, ISO, FIDI, and FAIMPLUS standards behind FSF service delivery.",
    "legacyUrl": "https://fsf.com.fj/quality-assurance-control/",
    "featuredImage": "/wp-content/uploads/2026/03/WEB-5.webp",
    "heroVideo": null,
    "links": [],
    "blocks": [
      {
        "type": "html",
        "html": "<h2><span><strong>QUALITY MANAGEMENT, ASSURANCE AND CONTROL </strong></span></h2><p>Fiji is a growing hub for logistics, tourism, and trade in the Pacific, and the number of companies holding Quality Management Standards is relatively small compared to larger, more developed regions. As a result, the certification serves as a clear indicator that <strong>Freight Services Fiji</strong> is a top-tier service provider that adheres to international quality management standards. To ensure that our services are held at a standard which benefits our customers, we have implemented the bible verse Matthew 6:33 in our business operations. In doing so, it directs our entire team to ensure that everything we do is done to ensure that we leave the world a better place than where we found it. Whether it’s putting a smile on others faces or helping those who need our help, ensuring that we remain focused towards the company cornerstone is a must as far as quality assurance and control is concerned.</p>"
      },
      {
        "type": "html",
        "html": "<p><em>At Freight Services Fiji, we understand that in the fast-paced and highly demanding world of logistics, ensuring quality is not just an option—it is a necessity. Our customers rely on us to handle their cargo, valuable</em> goods, and relocation needs with the highest level of care and professionalism. This is why we have integrated internationally recognized quality control measures into every aspect of our operations. By adhering to strict quality management systems, we ensure that every shipment, every service, and every customer interaction meets the highest standards of excellence.</p><h2><span><strong>QUALITY MANAGEMENT IN THE LOGISTICS INDUSTRY</strong></span></h2><p>Quality control is the backbone of any successful organization, but in logistics and freight forwarding, it plays an even more critical role. The movement of goods across cities, countries, and continents demands precision, timeliness, and reliability. A single delay, a minor mishap in handling, or a documentation error can lead to major disruptions, financial losses, and dissatisfied customers. This is why implementing rigorous quality control measures ensures that our customers are satisfied with each process of our services. Below, we detail how our quality control techniques provides benefits for us and all stakeholders we deal with:</p><p><span><strong>> Customer Confidence and Satisfaction:</strong></span></p><p>Freight Services Fiji demonstrates to our customers that we have a robust system in place to consistently provide high-quality services. This is critical in the logistics and freight forwarding industry where timely deliveries, safe handling, and communication are paramount. Customers can trust that their goods are in capable hands, reducing anxiety around potential delays or mishandling.</p><ul><li><span><strong>> Standardized Processes for Efficiency:</strong></span></li></ul><p>The QMS in place encourages all businesses that we work with to streamline their operations. With ISO 9001:2015 standard, Freight Services (Fiji) ensures all procedures, from the initial inquiry to final delivery, are well-documented, structured and archived. This leads to more predictable outcomes, less room for error, and ultimately, a more efficient service to our customers.</p><ul><li><span><strong>> Continuous Improvement:</strong></span></li></ul><p>The QMS places a strong emphasis on continuous improvement. This is beneficial for Freight Services Fiji because it creates a framework whereby we are constantly checking and assessing areas in which we may need to adjust further to enhance the overall quality in the services we provide. Regular audits and feedback loops ensure that our team is always learning, adapting, and finding new ways to improve the ultimate customer experience.</p><ul><li><span><strong>> Risk Management and Mitigation:</strong></span></li></ul><p>ISO 9001 encourages businesses to identify and manage risks that could affect their ability to meet customer expectations. For a logistics company like Freight Services Fiji, this could include supply chain disruptions, customs delays, or transportation issues. Having a QMS in place ensures you have contingency plans and are better prepared for unforeseen challenges.</p><ul><li><span><strong>> Professional Reputation:</strong></span></li></ul><p>Being certified enhances our credibility in the eyes of our customers, suppliers, and business partners. This is particularly important in the competitive field of freight forwarding and logistics, where reputation plays a key role in customer retention and attracting new clients. In Fiji and the broader Pacific region, achieving this certification sets us apart as a leader in this industry.</p><h2><span><strong><u>1. ISO 9001:2015 STANDARD – BSI (BRITISH STANDARDS INSTITUTION)</u></strong></span></h2><p>ISO 9001:2015 is an international standard for <strong>Quality Management Systems (QMS)</strong>. It sets out the criteria for a company to establish a consistent and effective framework for improving processes, customer satisfaction and service quality. Essentially, it’s a way to demonstrate that a company can meet customer and regulatory requirements while continuously improving its operations.</p><p>In many parts of the world, ISO 9001:2015 certification is widely recognized and expected from leading companies. However, in the Pacific Island region, including Fiji, ISO certification can be quite rare. This makes your company stand out, showing that <strong>Freight Services Fiji</strong> has gone above and beyond to ensure its customers receive the highest level of service. The certification adds credibility in both local and international markets. For customers considering shipping goods to or from Fiji, knowing that you are ISO certified gives them confidence in your ability to meet the highest standards of service, ensuring safe, timely, and cost-effective deliveries</p>"
      },
      {
        "type": "html",
        "html": "<p>At Freight Services Fiji, we are proud to have the British Standards Institution (BSI) as the certifying agency behind our ISO 9001:2015 certification. BSI is a globally recognized leader in standards development and certification, known for its commitment to excellence and rigorous auditing processes. Their reputation for professionalism and expertise is unmatched, ensuring that the standards we uphold meet the highest quality benchmarks in the industry. Being audited by such a prestigious organization is a testament to our dedication to continuous improvement and operational excellence. We consider ourselves incredibly fortunate to have the opportunity to work with BSI, as it reinforces our commitment to delivering superior services to our customers while maintaining the highest levels of quality and efficiency.</p>"
      },
      {
        "type": "html",
        "html": "<p>Being ISO 9001 certified enhances the credibility of our services in the eyes of our customers, suppliers, and partners. This is particularly important in the competitive field of freight forwarding and logistics, where reputation plays a key role in customer retention and attracting new clients. In Fiji and the broader Pacific region, achieving this certification sets you apart as a leader in quality management.</p>"
      },
      {
        "type": "html",
        "html": "<p>For <strong>Freight Services Fiji</strong>, the ISO 9001:2015 certification is a powerful tool that communicates your commitment to excellence. It provides a framework for continuous improvement, ensuring your operations run smoothly, efficiently, and in full alignment with customer expectations. In a region where such certifications are rare, it gives you a significant competitive edge and signals to customers that they can rely on your business for high-quality, professional logistics services. This certification isn’t just a badge—it’s a testament to the care and dedication your team puts into every shipment and customer interaction.</p><h2><span><strong><u>2. FIDI-FAIMPLUS QUALITY STANDARD – FIDI GLOBAL ALLIANCE</u></strong></span></h2><p>The FIDI FAIMPLUS certification is an internationally recognized quality management standard specifically designed for international moving and relocation companies. FIDI (Fédération Internationale des Déménageurs Internationaux) is a global network of professional moving companies, and FAIMPLUS is the highest level of their quality assurance program. It ensures that companies not only meet the minimum standards but also continuously strive for excellence in their operational practices. FAIMPLUS stands for “FIDI Accredited International Mover PLUS,” and it focuses on enhancing customer experience, improving operational efficiency, and promoting compliance with international best practices in the moving and relocation industry. This certification is especially rare in smaller markets like Fiji, where the infrastructure and resources for international logistics may be more limited than in larger, more developed countries. As a result, Freight Services Fiji can leverage its FAIMPLUS certification as a key selling point, emphasizing the international caliber of its services and its commitment to global standards of excellence.</p><p>At Freight Services Fiji, we are honoured to be fully compliant with the FIDI standard, a globally recognized quality management certification specifically tailored for international moving and relocation services. FIDI (Fédération Internationale des Déménageurs Internationaux) sets the benchmark for excellence in the moving industry, focusing on the highest levels of quality, safety, and customer satisfaction. By adhering to this rigorous standard, we demonstrate our commitment to providing reliable, efficient, and secure moving services to our clients, both locally and globally. FIDI certification ensures that we meet the exacting requirements for operational standards, employee training, customer service, and continuous improvement. Being compliant with the FIDI standard not only affirms our dedication to quality but also positions us as a trusted partner in the international relocation industry, where professionalism and reliability are paramount. We take great pride in upholding these standards, as they reflect our ongoing efforts to enhance service excellence and customer satisfaction at Freight Services Fiji.</p>"
      },
      {
        "type": "html",
        "html": "<p>The FAIMPLUS Standard is an elevated certification that builds upon the rigorous requirements of the FIDI standard, setting an even higher benchmark for excellence in the international moving and relocation industry. FAIMPLUS (FIDI Accredited International Movers Plus) is a prestigious and comprehensive quality management certification that requires companies to meet even stricter criteria in areas such as operational performance, customer satisfaction, security, sustainability, and compliance with international laws and regulations. Only a select few companies worldwide have the Honor of achieving FAIMPLUS certification, and it is a symbol of exceptional professionalism and dedication to continuous improvement. At Freight Services Fiji, we are truly blessed to be FAIMPLUS certified, as it demonstrates our commitment not only to meeting but exceeding the highest global standards in the moving industry. This certification further reinforces our promise to deliver top-tier services to our clients, while also positioning us as a trusted, elite player within the international moving community.</p>"
      },
      {
        "type": "html",
        "html": "<p>In a region where FIDI FAIMPLUS certification is rare, this certification serves as a clear indication of the exceptional quality of service you provide and reinforces your commitment to treating each customer with professional care and respect. Whether customers are moving locally or internationally, they can trust that Freight Services Fiji will deliver a top-tier, reliable, and seamless relocation experience. Achieving FIDI FAIMPLUS certification demonstrates that Freight Services Fiji is committed to maintaining the highest standards of service, professionalism, and customer satisfaction in the moving and relocation industry. This certification not only sets your company apart from competitors but also assures customers that they are working with a company that adheres to rigorous international quality standards.</p><h2><span><strong><u>REDEFINING LOGISTICS THROUGH A COMMITMENT TO QUALITY</u></strong></span></h2><p>At Freight Services Fiji, we do not compromise when it comes to quality. Our adherence to ISO 9001:2015, the FIDI Standard, and FAIMPLUS ensures that we deliver logistics and relocation services that are unmatched in quality, safety, and efficiency. These certifications not only connect us to other internationally accredited organizations but also reinforce our promise to provide world-class services that leave our customers satisfied, stress-free, and smiling. By investing in quality control at every level of our operations, we ensure that Freight Services Fiji remains the preferred choice for businesses and individuals seeking premium freight forwarding and moving services. When you choose us, you choose excellence, reliability, and a commitment to quality that goes beyond expectations.</p>"
      },
      {
        "type": "html",
        "html": "<h2><span><strong> </strong></span></h2><h2><span><strong>COMPANY CORNERSTONE – SEEK YE FIRST</strong></span></h2><p>Upholding the teachings mentioned by Christ in Matther Chapter 6:33 while conducting our daily operations is the cornerstone of our organization. Our management team has realized that following this unique and simple instruction time and time again ensures a job well done every time. Ensuring that the Most High is in control enables us to be a light to those around us by ensuring that the love of God is reflected in our actions.</p><p><strong><span><em><u>“But seek first the kingdom of God and His righteousness, </u></em></span></strong><strong><span><em><u>and all these things will be added to you,”</u></em></span></strong></p>"
      },
      {
        "type": "video",
        "url": "https://youtube.com/shorts/Q4MJU6rMx-E?si=smJmm5IYhEGbahC1"
      },
      {
        "type": "video",
        "url": "https://youtube.com/shorts/ujNd0_VO9I0?si=w9q85yrSoCxY_Jow"
      },
      {
        "type": "gallery",
        "images": [
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/03/bsi-1024x635.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/03/bsi2-1024x173.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/03/bsi3-1024x473.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/03/faim-1024x745.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/03/faim2-1024x1022.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/03/rad-867x1024.png",
            "alt": ""
          }
        ]
      }
    ]
  },
  "global-network": {
    "slug": "global-network",
    "title": "Global Network",
    "description": "Global partner networks connecting Fiji and the Pacific to international trade lanes.",
    "legacyUrl": "https://fsf.com.fj/global-network/",
    "featuredImage": "/wp-content/uploads/2022/05/IMG_1411-1024x683.jpg",
    "heroVideo": null,
    "links": [],
    "blocks": [
      {
        "type": "html",
        "html": "<p>As the South Pacific’s Global Cargo Hub, Freight Services Fiji considers it an honor to be a connector between the Pacific region and the rest of the World. We understand the significance of facilitating trade and promoting economic growth across borders, and we are dedicated to playing our part in making it happen. </p><p>Our extensive network of global partners and agents enables us to establish strong links between Pacific Island nations and major international markets. We strive to enhance accessibility, boost trade volumes, and foster mutually beneficial relationships that drive the economic development of the Pacific region.</p><p>Our goal is to bridge the geographical gaps, facilitate seamless trade and offer an amazing logistics experience to all our customers and relevant stakeholders. Join us as we travel on this journey of Connecting the Pacific to the World through Moving and Logistics Solutions.</p>"
      },
      {
        "type": "html",
        "html": "<p>The <span><strong>FIDI</strong> <strong>Global Alliance</strong></span> is the largest global alliance of international moving and relocation companies, with members in over 100 countries. It is a worldwide network of international movers and relocation service providers. The leading association in the global mobility industry, connecting companies that specialize in international moving and related services. <span><strong>FIDI’s</strong></span> aim is to promote and maintain high-quality standards in the industry, ensuring that customers receive reliable and professional service.  </p><p>By earning the <span><strong>FAIMPLUS</strong></span> certification — a rigorous, independently audited quality program — FSF has demonstrated compliance with strict operational, financial, and service benchmarks recognized worldwide. This membership connects us directly to trusted relocation and moving partners globally, ensuring that our customers receive professional, reliable, and standardized services no matter where they relocate. Carrying the FAIM seal means FSF is recognized as one of the best partners for international moves.</p><p>If a company carries the <span><strong>FAIM Quality Seal</strong></span>, you can be rest assured that you have found the best partner for your move.</p>"
      },
      {
        "type": "html",
        "html": "<p>Freight Services Fiji (FSF) becoming a member of <span><strong>IAM</strong> </span>signifies its affiliation with a prominent network of international movers. By joining<span> <strong>IAM</strong></span>, FSF gains access to a vast network of industry professionals, resources, and business opportunities that can contribute to its growth and development.  As an <span><strong>IAM</strong> </span>member, FSF is expected to uphold the association’s standards and code of ethics, which promote professionalism, integrity, and excellence in the moving industry.</p><p>This commitment helps ensure that FSF operates in accordance with recognized industry practices and customer expectations. <span> <strong>IAM</strong> </span>provides its members with various benefits, including access to educational programs, industry research, networking events, and a platform to exchange best practices and stay updated with the latest trends in the moving industry.</p>"
      },
      {
        "type": "html",
        "html": "<p>Overall, FSF’s membership in the <span><strong>International Association of Movers</strong> <strong>(IAM)</strong></span> showcases its dedication to maintaining high standards, engaging in industry collaboration, and delivering reliable and efficient moving services to customers all around the world.</p>"
      },
      {
        "type": "html",
        "html": "<h1><span><strong>IATA One Source</strong></span><span> is the International Air Transport Association’s comprehensive, digital industry directory that brings together thousands of aviation and logistics service providers worldwide. It allows airlines, freight forwarders, and shippers to easily identify and connect with registered logistics partners based on their capabilities, geographic coverage, and service offerings.</span></h1>"
      },
      {
        "type": "html",
        "html": "<p>Through this registration, FSF gains visibility on a <span><span><strong>global marketplace of trusted industry players</strong></span>,</span> showcasing our air freight services in <span><strong>Fiji and the wider Pacific region</strong></span>. While we are still on the pathway to full IATA Cargo Agent certification, being part of IATA One Source already provides key benefits, including:</p><ul><li><span><strong>International exposure</strong></span> to airlines and freight forwarders seeking partners in Fiji.</li><li><span><strong>Credibility</strong> </span>through association with IATA’s official global database.</li><li><span><strong>Opportunities for growth</strong></span>, building relationships with IATA-accredited carriers and partners.</li><li><span><strong>Preparation for accreditation</strong></span>, as participation encourages FSF to align its operations with IATA’s recognized standards.</li></ul><p>This strategic step reflects FSF’s dedication to transparency, global connectivity, and continuous improvement. By leveraging <span><strong>IATA One Source</strong></span>, FSF is strengthening its presence in the air cargo industry while steadily working towards full<span> <strong>IATA Cargo Agent Accreditation</strong></span> in the near future.</p>"
      },
      {
        "type": "html",
        "html": "<p>Freight Services Fiji (FSF) is proud to be certified under the <span><strong>Digital Freight Alliance (DFA)</strong></span> — an initiative by <span><strong>DP World</strong></span>, one of the world’s leading smart logistics providers. <span><strong>DP World</strong></span> is one of the world’s largest and most advanced logistics and port operators, connecting over 150 operations across 60 countries.</p>"
      },
      {
        "type": "html",
        "html": "<p>Through the <span><strong>DFA</strong></span>, FSF is now directly linked to this global hub, opening stronger trade connections with the <span><strong>Middle Eastern region</strong></span> and beyond. <span><strong>DFA</strong> </span>is a global network of freight forwarders connected through a digital platform, empowering members with access to end-to-end logistics solutions, digital tools, and global trade opportunities.</p>"
      },
      {
        "type": "html",
        "html": "<p>Being a part of the <span><strong>DFA</strong> </span>means FSF is backed by a trusted, tech-driven ecosystem designed to improve service delivery, pricing transparency, and operational efficiency across borders. This certification reflects our commitment to embracing innovation and providing our clients with faster, smarter, and more reliable logistics services worldwide.</p>"
      },
      {
        "type": "html",
        "html": "<p>The<span> <strong>FIATA</strong> <strong>(Federation of International Freight Forwarders Associations) </strong></span>is a global organization representing the freight forwarding industry. It serves as an umbrella association for national freight forwarder associations from around the world.<span> <strong>FIATA’s</strong></span> primary goal is to promote and enhance the role of freight forwarders in facilitating international trade and logistics all around the globe.</p>"
      },
      {
        "type": "html",
        "html": "<p>As part of <span><strong>FIATA</strong></span>, FSF is directly connected to international policy discussions, industry standards, and best practices that shape the global logistics sector. This membership gives FSF access to worldwide networks, training opportunities, and advocacy platforms — ensuring we remain compliant with international regulations and ahead of industry developments.</p><p>Being a <span><strong>FIATA member</strong> </span>reinforces FSF’s role as a trusted logistics partner with the credibility, knowledge, and global connectivity required to support customers across the international supply chain.</p>"
      },
      {
        "type": "html",
        "html": "<p>Freight Services Fiji (FSF) is a proud participant in the <span><strong>United Nations Global Compact (UNGC)</strong></span> — the world’s largest corporate sustainability initiative, headquartered in New York, USA. The <span><strong>UNGC</strong> </span>unites more than 20,000 companies and organizations across over 160 countries, bringing them together under the shared values of human rights, labour standards, environmental stewardship, and anti-corruption.</p><p>By joining the <span><strong>UNGC</strong></span>, FSF has committed itself to aligning our strategies and operations with the Ten Principles of the <strong><span>UNGC</span> </strong>and actively contributing to the achievement of the <span><strong>Sustainable Development Goals (SDGs)</strong></span> by 2030.</p><p>At FSF, this commitment translates into practical actions:</p><ul><li><strong><span>Environmental Responsibility</span></strong>: Reducing our carbon footprint through smarter route planning, investing in greener technologies, and minimizing waste in our operations.</li><li><span><strong>Social Responsibility</strong></span>: Ensuring fair labour practices, promoting workplace safety, and supporting local communities through outreach and capacity-building initiatives.</li><li><span><strong>Innovation & Education</strong></span>: Providing staff training and awareness programs to embed sustainability into daily decision-making and operations.</li></ul><p>Through these initiatives, FSF is not only adhering to the<span><strong> UNGC framework</strong></span> but also taking measurable steps toward the 2030 Agenda for Sustainable Development. This membership connects us to like-minded global businesses, strengthens our reputation as a responsible logistics partner, and ensures that our growth contributes positively to both people and the planet</p>"
      },
      {
        "type": "html",
        "html": "<p>Freight Services Fiji (FSF) is recognized as a CargoWise Certified Logistics Provider, demonstrating our advanced capability in utilizing one of the world’s leading integrated logistics platforms. CargoWise, developed by WiseTech Global and headquartered in Sydney, Australia, is a powerful, fully integrated supply chain software used by logistics companies worldwide to manage operations, improve visibility, and optimize workflows.</p>"
      },
      {
        "type": "html",
        "html": "<p>This certification signifies that FSF staff are thoroughly trained and proficient in using CargoWise, ensuring our operations are digitally streamlined, accurate, and responsive to global logistics demands. It enables FSF to connect efficiently with Australian, New Zealand, and broader international markets, giving us real-time control over freight movements, documentation, and compliance processes.</p><p>Additionally, CargoWise provides access to CargoWise Learning, an online platform offering professional development, industry best practices, and logistics insights for our team. This continuous learning ensures FSF’s staff remain highly skilled, knowledgeable, and capable of leveraging the latest logistics technology to provide faster processing, seamless coordination, and end-to-end supply chain solutions for our international customers.</p>"
      },
      {
        "type": "video",
        "url": "https://youtu.be/mCXngsStB2I?si=b8A1oz-lmgAig0B_"
      },
      {
        "type": "gallery",
        "images": [
          {
            "type": "image",
            "src": "/wp-content/uploads/2023/06/OOHub.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/FIDIX-1-1024x426.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/gn2.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/IAMXX-1-1024x220.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/gn4-421x1024.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2023/06/IAM2.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/IATAX-1024x216.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/IATAX2-1-1024x241.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/gn5.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/DFAX-1024x218.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/da2-1024x539.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/da3-1024x181.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/FIATAX-1024x214.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/iata1.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2023/06/Fiata.jpg",
            "alt": "Fiata"
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2026/02/gn6.png",
            "alt": "gn6"
          }
        ]
      }
    ]
  },
  "logistics": {
    "slug": "logistics",
    "title": "Logistics",
    "description": "End-to-end freight forwarding, customs, warehousing, transport, consolidation, and project cargo solutions.",
    "legacyUrl": "https://fsf.com.fj/logistics/",
    "featuredImage": "/wp-content/uploads/2022/05/IMG_1411-1024x683.jpg",
    "heroVideo": null,
    "links": [],
    "blocks": [
      {
        "type": "html",
        "html": "<h1><span><span><span>FREIGHT SERVICES FIJI: <span>LOGISTICS DIVISION</span></span></span></span></h1><p>The logistics division of Freight Services Fiji is the engine behind all commercial freight movement and supply chain services. It is structured to provide end-to-end logistics solutions for both local and international clients. Our expertise in freight and cargo movement is comprehensive, ensuring that goods reach their destination efficiently, safely, and cost-effectively. The division’s service areas include:</p><ul><li><span>International Freight Forwarding (Air Freight + Sea Freight)</span></li></ul><ul><li><span>Customs Brokerage & Clearance (Border Agency Solutions)</span></li></ul><ul><li><span>Warehousing Solutions (Product & Transit Warehousing)</span></li></ul><ul><li><span>Transport Solutions (Trucking & Haulage)</span></li></ul><ul><li><span>Cargo Consolidation (Cargo Freight Stations)</span></li></ul>"
      },
      {
        "type": "tabs",
        "items": [
          {
            "title": "Freight Forwarding",
            "html": "<p>Create better visibility and consistency in your supply chain through our end to end supply chain solutions. Optimize the product flow of your full container load (FCL) or less than container Load (LCL) and Loose Load (LSE)</p><h2>Air Products</h2><p>Depending on nature of goods and the urgency of cargo, our airfreight team are qualified or accredited to IATA that allow us to wide range of services.</p><ul><li>Pacific island Hub services</li><li>Courier services</li><li>Consolidation Services</li><li>Loose Air cargo (LSE)</li><li>Time Critical Management</li></ul><h2>Ocean Products</h2><p>Generally for all type of goods that the supplier wishes to sell or importer wish to buy. The two commonly use Incoterms are Delivered at Place (DAP) or Ex Works (EXW)</p><ul><li>Pacific Islands Hub Services</li><li>Ocean to Air conversion</li><li>Project Cargo</li><li>Personal effects handling</li><li>OOG Cargo</li></ul>"
          },
          {
            "title": "Customs Clearance",
            "html": "<p>A well-trained team guaranteed the efficient handling of import, export and transit formalities.</p><h3>INHOUSE SERVICES</h3><p>Efficient data handling and Landed costing</p><h3>TRANS-SHIPMENT</h3><p>Electronic, Quarantine formalities</p><h3>CONSULTANCY</h3><ul><li>Technical Valuation</li><li>Legislation and</li><li>Tariff consultation</li></ul>"
          },
          {
            "title": "Warehousing",
            "html": "<p>With 1000 m2 warehouse facilities at our disposal, we can ensure efficient distribution solution to your goods.</p><h2>Transit WHS </h2><p>Our facility is license and approved BIO & CUSTOMS facility. We offer real-time visibility of goods and fast handling of barcoded pallets or packages.</p><h2>Product</h2><p>3PL warehouse facility manage and track the movement of your inventory.</p><h2>Bonded</h2><p>Cost saving bond warehouse offer needed support for any business who wish to hold stock and or distribute directly to customers door.</p>"
          },
          {
            "title": "Transport Solutions",
            "html": "<p>FSF Logistics provide cost efficient intermodal, multimodal transport solutions via air, sea road and ferries</p><h2>Full Truck Load (FTL)</h2><ul><li>Depending on nature of goods and the urgency of cargo, our airfreight team are qualified or accredited to IATA that allow us to wide range of services. We offer the following services:</li><li>Pacific island Transit services</li><li>Courier services</li><li>Consolidation Services</li><li>Loose Air cargo (LSE)</li><li>Time Critical Management</li></ul><h2> Less Truck Load (LTL)</h2><ul><li>The hike in transportation (<i>post </i><i>covid</i>) has position supplier and buyers to consider how best they can control their cost and at the same time secure a load. The shift in buying terms has impact forwarder at the border. The two commonly use are Delivered at Place (DAP) or Ex Works (EXW) Incoterms.</li><li>Pacific Islands Hub Services</li><li>Ocean to Air conversion</li><li>Project Cargo</li><li>Personal effects handling</li><li>OOG Cargo</li></ul>"
          },
          {
            "title": "Cargo Consolidation",
            "html": "<p>Import or Export (Air or Ocean) cargo consolidation from any port.</p><h2><b>Buyers Consolidation (BCN)</b></h2><p>Solution provided for customers (importers) who use multiple suppliers LCL/FCL.</p><h2><b>Deconsolidation (Import)</b></h2><p>Solution provided for freight forwarder’s inbound groupage container.</p><p>Reduce freight & handling cost and streamlining the process.</p><h2><b>Export Groupage</b></h2><p>Solution provided exporters who ship less than container.</p>"
          },
          {
            "title": "Project Cargo",
            "html": "<p>Tab Content</p>"
          },
          {
            "title": "Web tracker (NEW)",
            "html": "<p>Tab Content</p>"
          }
        ]
      }
    ]
  },
  "moving": {
    "slug": "moving",
    "title": "Moving",
    "description": "International and domestic relocation services for households, pets, vehicles, baggage, and exhibitions.",
    "legacyUrl": "https://fsf.com.fj/moving/",
    "featuredImage": "/wp-content/uploads/2022/05/IMG_1741.jpg",
    "heroVideo": null,
    "links": [],
    "blocks": [
      {
        "type": "html",
        "html": "<h3><span>“Moving/Relocating to a new place can be tough. Luckily, the whole process just becomes so much easier with us”</span></h3>"
      },
      {
        "type": "tabs",
        "items": [
          {
            "title": "International",
            "html": "<h2>Moving overseas</h2><p>We are Fiji’s overseas moving specialist, we have international relationship, custom knowledge and proven processes to guarantee a successful move.</p><p>We are the most experienced international moving company in Fiji and connecting to 14 small pacific islands.</p><p><strong>Assured Quality.</strong> We are the only accredited moving company in Fiji</p>"
          },
          {
            "title": "Domestic",
            "html": "<p>When moving house in Fiji, some may think it may seem so simple or Freight Services (Moving) only handle the international. The truth is, no one is better equipped to provide with local moving services!</p><p>We are the most experienced international moving company in Fiji and connecting to 14 small pacific islands.</p>"
          },
          {
            "title": "Pet",
            "html": "<h2>PET Transport & Relocation</h2><p>Please don’t leave your friends behind. We transport your pets safely to your home</p>"
          },
          {
            "title": "Motor Vehicle",
            "html": "<p>Personal Motor Vehicle (Import & Export)</p><ul><li>We have the expertise to safely and securely transport your wheels anywhere globally</li><li>We offer inbound clearance & Registration services</li><li>We provide export packing and shipping</li></ul>"
          },
          {
            "title": "Insurance",
            "html": "<p>Insurance Options</p><ul><li>Full replacement value (old to new)</li><li>Packing and Moving Insurance</li><li>Local & Transit insurance cover</li><li>30days free storage</li><li>Owner pack cover</li></ul>"
          },
          {
            "title": "Transit",
            "html": "<p>Transit & Storage Insurance</p><p>FSF consider all necessary precautions to protect your possessions. However there are many areas of risk that need to considered when moving such as weather, accidents, vibration, shock, pressure and temperature changes</p><p>Lean more..</p>"
          },
          {
            "title": "Excess Baggage",
            "html": "<p>Excess Baggage</p><p>Through our forwarding department, we can move excess baggage by air & ocean</p>"
          },
          {
            "title": "Exhibitions",
            "html": "<p>Exhibitions</p><p>Will you be exhibiting abroad or in the islands. FSF Moving provides smooth logistic operations.</p>"
          }
        ]
      }
    ]
  },
  "contactus": {
    "slug": "contactus",
    "title": "Contact Us",
    "description": "Contact Freight Services Fiji for general enquiries, quotations, branch details, and service support.",
    "legacyUrl": "https://fsf.com.fj/contactus/",
    "featuredImage": "/wp-content/uploads/2023/06/pacific2-e1752799273593.png",
    "heroVideo": null,
    "links": [
      {
        "label": "Home",
        "href": "/home/"
      },
      {
        "label": "About Us",
        "href": "/#"
      },
      {
        "label": "In The Beginning",
        "href": "/about-us/"
      },
      {
        "label": "Our Ethics, Values & Culture",
        "href": "/our-ethics-values-culture/"
      },
      {
        "label": "Quality Assurance & Control",
        "href": "/quality-assurance-control/"
      },
      {
        "label": "Global Network & Partners",
        "href": "/global-network/"
      },
      {
        "label": "Logistics Division",
        "href": "/logistics/"
      },
      {
        "label": "Moving Division",
        "href": "/moving/"
      },
      {
        "label": "Contact Us",
        "href": "/contactus/"
      },
      {
        "label": "Login",
        "href": "https://fslsuv.webtracker.wisegrid.net/Login/Login.aspx?ReturnUrl=%2fDefault.aspx"
      },
      {
        "label": "Email: info@fsf.com.fj",
        "href": "mailto:info@fsf.com.fj"
      }
    ],
    "blocks": [
      {
        "type": "html",
        "html": "<p>Scan QR Code Via Your Mobile Device or Click on Start Now on image below to request for a quotation</p>"
      },
      {
        "type": "gallery",
        "images": [
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/FSFLogoH-300x62.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2023/12/original-0F6419F0-D0D5-45CE-8DF2-16D7F4B4A20B-295x300.jpeg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2023/12/image.png",
            "alt": ""
          }
        ]
      }
    ]
  },
  "solutions": {
    "slug": "solutions",
    "title": "Solutions",
    "description": "",
    "legacyUrl": "https://fsf.com.fj/solutions/",
    "featuredImage": null,
    "heroVideo": null,
    "links": [
      {
        "label": "Transit Warehouse Solutions",
        "href": "/transit-whs/"
      },
      {
        "label": "3PL | Distribution & Fulfilment",
        "href": "/ocean-products/"
      },
      {
        "label": "Warehouse Storage Solutions",
        "href": "/airproducts/"
      },
      {
        "label": "Moving & Relocation Services",
        "href": "/insurance-product/"
      },
      {
        "label": "Forwarding – Air Freight Solutions",
        "href": "/air-product/"
      },
      {
        "label": "Forwarding – Sea Freight Solutions",
        "href": "/ocean-product/"
      },
      {
        "label": "Forwarding",
        "href": "/forwarding-services/"
      },
      {
        "label": "ISO Compliance",
        "href": "/iso-compliance/"
      },
      {
        "label": "Moving",
        "href": "/project-cargo/"
      },
      {
        "label": "Transport",
        "href": "/trade-consultancy/"
      },
      {
        "label": "Storage",
        "href": "/baggage-services/"
      },
      {
        "label": "Transport Solutions",
        "href": "/transportsolutions/"
      }
    ],
    "blocks": [
      {
        "type": "gallery",
        "images": [
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/IMG_0298-300x200.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/0-02-07-6fbbca32cfcce14cacb8f6840ff6231a22cb5a60a09b51c746b1854e8c1c3c7a_73d83be445ed67b-225x300.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/IMG_1166-300x200.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/0-02-07-7339a65a118bb0806c30829a0c49b2c38521d06cc57b7e897009fcd98975ae77_5bd26a4180b3e1dd-Copy-225x300.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/09/AIRR-e1771834117452-300x220.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/IMG_1411-300x200.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/09/foreman-control-loading-containers-box-truck-300x200.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/IMG_1185-300x200.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/IMG_1365-300x200.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/IMG_1359-300x200.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/IMG_0308-300x200.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/IMG_1741-300x200.jpg",
            "alt": ""
          }
        ]
      }
    ]
  },
  "solutions2": {
    "slug": "solutions2",
    "title": "Solutions2",
    "description": "",
    "legacyUrl": "https://fsf.com.fj/solutions2/",
    "featuredImage": null,
    "heroVideo": null,
    "links": [
      {
        "label": "Baggage Declaration CE 111 (mandatory form)",
        "href": "/wp-content/uploads/2022/09/Baggage-Declaration-C.E.111.pdf"
      },
      {
        "label": "Personal Import Motor vehicle (Guidelines)",
        "href": "/wp-content/uploads/2022/09/MV-Import-Requirement.pdf"
      },
      {
        "label": "MEPSL Application Form (Import of freezer, fridge and related)",
        "href": "/wp-content/uploads/2022/09/MEPSL-FORM.pdf"
      },
      {
        "label": "Transit Warehouse Solutions",
        "href": "/transit-whs/"
      },
      {
        "label": "3PL | Distribution & Fulfilment",
        "href": "/ocean-products/"
      },
      {
        "label": "Warehouse Storage Solutions",
        "href": "/airproducts/"
      },
      {
        "label": "Moving & Relocation Services",
        "href": "/insurance-product/"
      },
      {
        "label": "Forwarding – Air Freight Solutions",
        "href": "/air-product/"
      },
      {
        "label": "Forwarding – Sea Freight Solutions",
        "href": "/ocean-product/"
      }
    ],
    "blocks": [
      {
        "type": "gallery",
        "images": [
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/IMG_0298-300x200.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/0-02-07-6fbbca32cfcce14cacb8f6840ff6231a22cb5a60a09b51c746b1854e8c1c3c7a_73d83be445ed67b-225x300.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/IMG_1166-300x200.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/0-02-07-7339a65a118bb0806c30829a0c49b2c38521d06cc57b7e897009fcd98975ae77_5bd26a4180b3e1dd-Copy-225x300.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/09/AIRR-e1771834117452-300x220.jpg",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/IMG_1411-300x200.jpg",
            "alt": ""
          }
        ]
      }
    ]
  },
  "storage-solutions": {
    "slug": "storage-solutions",
    "title": "Storage Solutions",
    "description": "",
    "legacyUrl": "https://fsf.com.fj/storage-solutions/",
    "featuredImage": null,
    "heroVideo": null,
    "links": [],
    "blocks": [
      {
        "type": "html",
        "html": "<p>Freight Services offer self and warehouse storage in Suva for commercial and private. Our units range from 5cbm to 50cbm and ca be used for temporary or permanent storage. We are accessible every day from 8am to 5pm</p>"
      },
      {
        "type": "html",
        "html": "<h2>Short Term</h2><p>This is best for individual or business who moving to a new house or office, renovation and travelling. A short term storage can keep your belongings safe and secured.</p>"
      },
      {
        "type": "html",
        "html": "<h2>Long Term</h2><p>For a decades, FSF Moving has helped families and friends taking stress out of moving, we are your local removalist.</p>"
      },
      {
        "type": "html",
        "html": "<h2>Moving Boxes</h2><p>Please don’t leave your friends behind. We transport your pets safely to your home.</p>"
      },
      {
        "type": "html",
        "html": "<h2>Storage Insurance</h2><p>We continue to review our storage facility safe, secure and risk free. As always, the risk will remain hence for our solution to protect our customer from such exposure.</p>"
      },
      {
        "type": "gallery",
        "images": [
          {
            "type": "image",
            "src": "/wp-content/uploads/2023/03/Str1.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2023/03/str2.jpg",
            "alt": ""
          }
        ]
      }
    ]
  },
  "our-values": {
    "slug": "our-values",
    "title": "Our Values",
    "description": "",
    "legacyUrl": "https://fsf.com.fj/our-values/",
    "featuredImage": null,
    "heroVideo": null,
    "links": [
      {
        "label": "> ENVIRONMENT POLICY",
        "href": "/wp-content/uploads/2022/08/ENV-Policy.pdf"
      }
    ],
    "blocks": [
      {
        "type": "html",
        "html": "<h2><strong>LEADERSHIP</strong></h2><p>FSF recognize that not everyone will be a leader though we can demonstrate by upholding quality practice, advocate compliance to internal and external requirements</p>"
      },
      {
        "type": "html",
        "html": "<h2><strong>QUALITY</strong></h2><p>FSF periodically review, recommend, measure our commitment to international and national standards</p>"
      },
      {
        "type": "html",
        "html": "<h2><strong>TRANSPARENCY </strong></h2><p>We define transparency as honest, crystal clear communication and decision making in the way the company conduct its business.</p>"
      },
      {
        "type": "html",
        "html": "<h2><strong>COMMUNICATION</strong></h2><p>Effective communication is the most important role that guarantee customer services excellence. FSF has automated system that triggers milestone ensuring client is continuously updated through out every step of a journey.</p>"
      },
      {
        "type": "html",
        "html": "<h2><strong>COMMITMENT TO TECHNOLOGY </strong></h2><p>FSF is a certified Cargowise logistics provider. The cloud base operating platform offer complete supply chain integrated solutions to allow a smooth and transparent.</p><ul><li><ul><li>CW1</li><li>TRACKING & REPORTING</li><li>SECURITY & PRIVACY</li></ul></li></ul>"
      },
      {
        "type": "html",
        "html": "<h2><strong>CORPORATE SOCIAL RESPONSIBILITY </strong></h2><p>We subscribe to FIDI <u>anti-bribery</u>, <u>anti-corruption</u>, <u>anti-trust</u> and audit for compliance through our membership with international associations and affiliation.</p><p><strong><a href=\"/wp-content/uploads/2022/08/ENV-Policy.pdf\">> ENVIRONMENT POLICY</a></strong></p>"
      },
      {
        "type": "html",
        "html": "<h2><strong>CUSTOMER</strong></h2><h3>“You are the reason we exist”.</h3><p>Custom designed transportation services for all our client- from large organisation with existing internal procedures, to small business in need of special assistance and individual require detail care.</p>"
      },
      {
        "type": "html",
        "html": "<h2><strong>PEOPLE</strong></h2><h3>‘Our biggest asset”</h3><p>We are competent, friendly, honest and value our customers need.</p>"
      },
      {
        "type": "html",
        "html": "<h2><strong>History </strong></h2><p>Freight Services the company was formed in 1996 during the peak of our textile and clothing industry in Fiji.</p>"
      },
      {
        "type": "gallery",
        "images": [
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/09/icon-leadership.png",
            "alt": "icon - leadership"
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/09/icon-quality.png",
            "alt": "icon - quality"
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/09/icon-transparency.png",
            "alt": "icon - transparency"
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/09/icon-communication.png",
            "alt": "icon - communication"
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/09/icon-technology.png",
            "alt": "icon - technology"
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/09/icon-csr.png",
            "alt": "icon - csr"
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/09/icon-customer.png",
            "alt": "icon - customer"
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/09/icon-people.png",
            "alt": "icon - people"
          }
        ]
      }
    ]
  },
  "corporate-social-responsibility-2": {
    "slug": "corporate-social-responsibility-2",
    "title": "Corporate Social Responsibility",
    "description": "Responsible logistics, sustainable development, and care for the communities we serve.",
    "legacyUrl": "https://fsf.com.fj/corporate-social-responsibility-2/",
    "featuredImage": "/wp-content/uploads/2026/02/3.jpg",
    "heroVideo": null,
    "links": [],
    "blocks": [
      {
        "type": "gallery",
        "images": [
          {
            "type": "image",
            "src": "/wp-content/uploads/2023/04/CSR_Page_1.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2023/04/CSR_Page_2-725x1024.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2023/04/CSR_Page_3-725x1024.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2023/04/CSR_Page_4-725x1024.png",
            "alt": ""
          }
        ]
      }
    ]
  },
  "customer-review-form-2": {
    "slug": "customer-review-form-2",
    "title": "Customer Review Form",
    "description": "",
    "legacyUrl": "https://fsf.com.fj/customer-review-form-2/",
    "featuredImage": null,
    "heroVideo": null,
    "links": [
      {
        "label": "Instagram",
        "href": "https://www.instagram.com/freightservicesfiji/"
      },
      {
        "label": "Facebook",
        "href": "https://www.facebook.com/freightservicesfiji/?notif_id=1658272955934821&notif_t=page_fan&ref=notif"
      },
      {
        "label": "Youtube",
        "href": "https://www.youtube.com/channel/UCZTjJ_Qd8M7dS6-hJbH6CSA"
      },
      {
        "label": "Linkedin",
        "href": "https://www.linkedin.com/company/freight-services-fiji-ltd-suva/"
      },
      {
        "label": "Snapchat",
        "href": "https://www.snapchat.com/add/freightservices?share_id=RkY2MEZDNUMtRDVBNy00NjJBLUEyQTAtRUIyNTk4QUE4RUE0&locale=en_FJ"
      },
      {
        "label": "Privacy Policy",
        "href": "/wp-content/uploads/2022/08/SOP-ADMDPP-01-Data-Privacy-and-Protection-Procedure.pdf"
      },
      {
        "label": "Anti Bribery Charter",
        "href": "/wp-content/uploads/2022/08/Anti-Bribery.pdf"
      },
      {
        "label": "Anti Trust Charter",
        "href": "/wp-content/uploads/2022/08/Anti-Trust-Charter.pdf"
      },
      {
        "label": "Disclaimer",
        "href": "/wp-content/uploads/2022/08/CSR-Policy.pdf"
      }
    ],
    "blocks": [
      {
        "type": "gallery",
        "images": [
          {
            "type": "image",
            "src": "/wp-content/uploads/2022/05/FSFLogoHW-300x62.png",
            "alt": ""
          }
        ]
      }
    ]
  },
  "privacy-notice": {
    "slug": "privacy-notice",
    "title": "Data Privacy Notice",
    "description": "",
    "legacyUrl": "https://fsf.com.fj/privacy-notice/",
    "featuredImage": null,
    "heroVideo": null,
    "links": [],
    "blocks": [
      {
        "type": "gallery",
        "images": [
          {
            "type": "image",
            "src": "/wp-content/uploads/2023/04/DPN_Page_1-725x1024.png",
            "alt": ""
          },
          {
            "type": "image",
            "src": "/wp-content/uploads/2023/04/DPN_Page_2-725x1024.png",
            "alt": ""
          }
        ]
      }
    ]
  },
  "disclaimer": {
    "slug": "disclaimer",
    "title": "Disclaimer",
    "description": "",
    "legacyUrl": "https://fsf.com.fj/disclaimer/",
    "featuredImage": null,
    "heroVideo": null,
    "links": [],
    "blocks": [
      {
        "type": "gallery",
        "images": [
          {
            "type": "image",
            "src": "/wp-content/uploads/2023/04/Disclaimer-725x1024.png",
            "alt": ""
          }
        ]
      }
    ]
  }
};
